import { Link } from "react-router-dom";
import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { LogoMark } from "@/components/Navbar";
import { CONTACT } from "@/pages/Contact";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-aspira-dark text-aspira-cream">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <LogoMark footer />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-aspira-cream/60">
            Aspira Property Group works with landowners looking to sell vacant
            land and buyers searching for real estate opportunities. We strive to
            make buying and selling land a straightforward, transparent
            experience.
          </p>
        </div>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-aspira-gold">Explore</p>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["Home", "/", "footer-home"],
              ["Sell Your Land", "/sell", "footer-sell"],
              ["Buy Land", "/buy", "footer-buy"],
              ["About Us", "/about", "footer-about"],
              ["Contact", "/contact", "footer-contact"],
            ].map(([name, path, id]) => (
              <li key={path}>
                <Link
                  to={path}
                  data-testid={id}
                  className="text-aspira-cream/70 transition-colors duration-200 hover:text-aspira-gold"
                >
                  {name}
                </Link>
              </li>
            ))}
          </ul>
          <ul className="mt-6 space-y-3 border-t border-white/10 pt-5 text-sm">
            <li>
              <Link to="/privacy" data-testid="footer-privacy" className="text-aspira-cream/50 transition-colors duration-200 hover:text-aspira-gold">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" data-testid="footer-terms" className="text-aspira-cream/50 transition-colors duration-200 hover:text-aspira-gold">
                Terms of Use
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-aspira-gold">Contact</p>
          <div className="mt-5 space-y-3 text-sm">
            <a
              href={CONTACT.phoneHref}
              data-testid="footer-phone"
              className="flex items-center gap-3 text-aspira-cream/70 transition-colors duration-200 hover:text-aspira-gold"
            >
              <Phone size={15} className="text-aspira-gold" /> {CONTACT.phone}
            </a>
            <a
              href={CONTACT.emailHref}
              data-testid="footer-email"
              className="flex items-center gap-3 text-aspira-cream/70 transition-colors duration-200 hover:text-aspira-gold"
            >
              <Mail size={15} className="text-aspira-gold" /> {CONTACT.email}
            </a>
          </div>
          <div className="mt-6 flex flex-col gap-3">
            <Link
              to="/sell"
              data-testid="footer-cta-sell"
              className="group inline-flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-5 py-4 text-sm font-medium transition-colors duration-300 hover:border-aspira-gold/50 hover:bg-white/10"
            >
              Request a cash offer
              <ArrowUpRight size={16} className="text-aspira-gold transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <Link
              to="/buy"
              data-testid="footer-cta-buy"
              className="group inline-flex items-center justify-between rounded-2xl border border-white/10 bg-white/5 px-5 py-4 text-sm font-medium transition-colors duration-300 hover:border-aspira-gold/50 hover:bg-white/10"
            >
              Browse available land
              <ArrowUpRight size={16} className="text-aspira-gold transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </div>
      </div>
      <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 text-xs text-aspira-cream/40 sm:flex-row sm:items-center">
        <p>© {new Date().getFullYear()} Aspira Property Group. All rights reserved.</p>
        <p className="font-serif italic text-aspira-gold/80">Your land. Your next chapter.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
